import { z } from 'zod/v4'
import { aiFunction } from './functions.schema.js'
import { aiModelsSchema, aiProviderSchema } from './providers.js'

export const chatMessage = z.object({
  role: z.enum(['user', 'system', 'assistant']).describe('The role of the message'),
  content: z.string(),

  function_call: z
    .union([
      z.object({
        name: z.string(),
        arguments: z.string(),
      }),
      z.null(),
    ])
    .optional(),
})
export type ChatMessage = z.infer<typeof chatMessage>

/** For use when streaming message to ensure we know when messages are complete */
export const chatMessageStream = chatMessage.extend({
  pending: z.boolean().describe('Whether the completion is still pending (incremental load)').optional(),
})
export type ChatMessageStream = z.infer<typeof chatMessageStream>

/** @todo move this to the ai-lib package */
export const chatPayloadSchema = z.object({
  temperature: z.number().default(0.5).optional(),
  providerName: aiProviderSchema.default('openai'),
  prompt: z.array(chatMessage),
  functions: z.array(aiFunction).optional(),
  model: aiModelsSchema.optional(),
  parentChatId: z.string().describe('If specified, add a completed comment to the specified chat').optional(),
})

export type ChatPayload = z.infer<typeof chatPayloadSchema>

/** @todo this is not correct with the new AI SDK */
export const chatResponseSchema = z.object({
  completions: z.array(
    z.object({
      message: chatMessage,
      finish_reason: z.string(),
    })
  ),
  text: z.string(),
  tokens: z.number(),
})
export type ChatResponse = z.infer<typeof chatResponseSchema>
